module.exports = __webpack_public_path__ + "img/eco_line.5abe9aea.png";